// loading app routes
import todo from './todo'
import available_property from './available_property'
import property from './property'
import transaction from './transaction'

export default [{
        path: 'utility',
        name: 'appUtility',
        redirect: { name: 'appUtilityTodo' },
        meta: {
            title: 'utility.utility',
            icon: 'fas fa-tools',
            isNotNav: 'config.system.todo',
            isHiddenNav: true,
        },
        component: {
            template: '<router-view></router-view>'
        },
        children: [            
            ...available_property,
            ...property,
            ...transaction,
            ...todo,            
        ]
    },
]
